
export function smsButtonHandler(changeStatusHandler, visitorInfo) {
    changeStatusHandler(visitorInfo, '조건미충족');
}
export function approveButtonHandler(changeStatusHandler, visitorInfo) {
    console.log('approveButtonHandler', visitorInfo);
    changeStatusHandler(visitorInfo, '승인');
}

export function rejectButtonHandler(changeStatusHandler, visitorInfo) {
    console.log('rejectButtonHandler', visitorInfo);
    changeStatusHandler(visitorInfo, '반려');
}

export function qrReSendHandler(changeStatusHandler, visitorInfo) {
    console.log('qrReSendHandler', visitorInfo);
    changeStatusHandler(visitorInfo, 'QR_RE_SEND');
}

export function inButtonHandler(changeStatusHandler, visitorInfo) {
    console.log('inOutButtonHandler', visitorInfo);
    // changeStatusHandler(visitorInfo, 'COME_IN');
    window.open(`/in-out/${visitorInfo.seq}`, '_blank');
}

export function outButtonHandler(changeStatusHandler, visitorInfo) {
    console.log('inOutButtonHandler', visitorInfo);
    window.open(`/in-out/${visitorInfo.seq}`, '_blank');
    // changeStatusHandler(visitorInfo, 'GO_OUT');
}

export function convertStatus(visitorStatus) {
    switch (visitorStatus) {
        case 'APPROVED' :
            return '승인';
        case 'REJECT' :
            return '반려';
        case 'NOT_APPROVED' :
            return '미승인';
            break;
        case 'COME_IN' :
            return '입문';
        case 'GO_OUT' :
            return '출문';
    }
}

export function makeItem(changeStatusHandler, visitorInfo) {
    let items = new Array();
    switch (visitorInfo.visitorStatus) {
        case '조건미충족' :
            items.push({
                innerHTML:'안내발송',
                onClickHandler:() => smsButtonHandler(changeStatusHandler, visitorInfo)
            })
            items.push({
                innerHTML:'반려',
                onClickHandler:() => rejectButtonHandler(changeStatusHandler, visitorInfo)
            })
            break;
        case '승인' :
            items.push({
                innerHTML:'QR재발급',
                onClickHandler:() => qrReSendHandler(changeStatusHandler, visitorInfo)
            })
            items.push({
                innerHTML:'입문',
                onClickHandler:() => inButtonHandler(changeStatusHandler, visitorInfo)
            })
            items.push({
                innerHTML:'반려',
                onClickHandler:() => rejectButtonHandler(changeStatusHandler, visitorInfo)
            })
            break;
        case '미승인' :
            items.push({
                innerHTML:'승인',
                onClickHandler:() => approveButtonHandler(changeStatusHandler, visitorInfo)
            })
            items.push({
                innerHTML:'반려',
                onClickHandler:() => rejectButtonHandler(changeStatusHandler, visitorInfo)
            })
            break;
        case '입문' :
            items.push({
                innerHTML:'출문',
                onClickHandler:() => outButtonHandler(changeStatusHandler, visitorInfo)
            })
            break;
        case '출문' :
            items.push({
                innerHTML:'반려',
                onClickHandler:() => rejectButtonHandler(changeStatusHandler, visitorInfo)
            })
            break;
    }
    return items;
}